module.exports = __webpack_public_path__ + "img/logo.1729f4c2.png";